import { IField, IFormButton } from 'app/services/api5-service/api.interface';

import { DocHelper } from 'utils/dochelper';

import { TypedControlBase } from '../typed-controls';

export interface ButtonControl extends TypedControlBase {
  readonly control: IFormButton;
  readonly type: 'button';
}

/**
 * Map control metadata to typed object with value from doc state
 *
 * @param field - field metadata
 */
export function getTypeControlsForButton(field: IField): ButtonControl[] {
  const buttons = DocHelper.getArrayWrapperValue(field.button);
  return buttons
    .filter(
      button => button.$position !== 'underfield' && button.$hidden !== 'yes',
    )
    .map<ButtonControl>(control => {
      return {
        control,
        type: 'button',
      } as ButtonControl;
    });
}
